import { A } from '@works-web/settings/modules/browser';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '~/settings/__modules__/component';
import {
  CommonService,
  UserOptionName,
} from '~/settings/service/CommonService';

export function AutoReplyInternal() {
  const { t } = useTranslation();
  let enable = false;
  let optionInternal = CommonService.getOptionValue(
    UserOptionName.Auto_Reply_Internal,
  );

  if (optionInternal) {
    optionInternal = JSON.parse(optionInternal);
    enable = optionInternal.enable;
  }

  return (
    <li className="item has_link">
      <div className="title_area">
        <h4 className="title">
          <span className="text">{t('talk_main_replytitle_internal')}</span>
          <Tooltip>{t('talk_main_tooltip5')}</Tooltip>
        </h4>
      </div>
      <span className="status">
        {enable ? t('talk_main_replystatus1') : t('talk_main_replystatus2')}
      </span>
      <A href="/settings/autoreplyinternal" className="link_more">
        <i className="blind">Go to detail</i>
      </A>
    </li>
  );
}
